export default async ({ $axios, store }) => {
  try {
    const data = await $axios.$get('https://featuregate.api-used.ru/api/features/silent', {
      timeout: 1000
    })

    if (data && data.enabled) {
      store.commit('features/features/SET_SILENT_STATUS', true)
    } else {
      store.commit('features/features/SET_SILENT_STATUS', false)
    }
  } catch (e) {
    store.commit('features/features/SET_SILENT_STATUS', false)
  }
}
